import type { OverviewResponse } from "contracts/api/dashboard/responses";
import type { Issue } from "contracts/api/issue/responses";
import { For } from "solid-js";
import { SeverityBadge } from "../../ui/Badge";
import { summaryPriorityFamilies } from "./summaryPriorityFamilies";

export function Priorities(props: {
  data: OverviewResponse;
  openQuickLook: (issue: Issue) => void;
}) {
  const families = () => summaryPriorityFamilies(props.data, 4);
  return (
    <section class="signal-panel">
      <div class="signal-panel-head">
        <div>
          <h2>Priorities</h2>
          <p>The most important problems and what to do next</p>
        </div>
        <span>{families().length} shown</span>
      </div>
      <div class="signal-priority-list">
        <For each={families()}>
          {(family, index) => (
            <article class="signal-priority-item">
              <button
                type="button"
                onClick={() => props.openQuickLook(family.representative)}
              >
                <span class="signal-rank" aria-hidden="true">
                  {index() + 1}
                </span>
                <SeverityBadge severity={family.severity} />
                <span class="signal-priority-copy">
                  <strong>{family.title}</strong>
                  <small>
                    {family.dimension} / {family.scope}
                    {family.relatedIssueCount > 1
                      ? ` / ${family.relatedIssueCount} related issues`
                      : ""}
                  </small>
                  <span class="signal-priority-next-step">
                    <b>Next step</b>
                    {family.action}
                  </span>
                </span>
              </button>
              <a
                href={`/w/${props.data.site.websiteId}/scan/issues/${family.representative.id}?from=summary`}
              >
                Open issue
              </a>
            </article>
          )}
        </For>
      </div>
    </section>
  );
}
